jQuery(function ($) {
    // Style jQuery UI checkboxes and radio buttons.
    $('.checkboxradio').checkboxradio();

    // Configure jQuery UI date pickers.
    $.datepicker.setDefaults({
        // Localization. Easier to inline it here than load it from an external
        // source.
        dateFormat: 'dd-mm-yyyy',
        firstDay: 1, // Monday
        currentText: 'Vandaag',
        nextText: 'Volgende',
        prevText: 'Vorige',
        closeText: 'OK',
        weekHeader: 'Wk',
        dayNames: ['zondag', 'maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag'],
        dayNamesMin: ['zo', 'ma', 'di', 'wo', 'do', 'vr', 'za'],
        dayNamesShort: ['zon', 'maa', 'din', 'woe', 'don', 'vrij', 'zat'],
        monthNames: ['Januari', 'Februari', 'Maart', 'April', 'Mei', 'Juni', 'Juli', 'Augustus', 'September', 'Oktober', 'November', 'December'],
        monthNamesShort: ['jan', 'feb', 'mrt', 'apr', 'mei', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'dec'],
    });

    // Sticky page headers
    $('.sticky-anchor').each(function() {
        var doc = $(document);
        var anchor = $(this);
        var content = $(anchor.attr('data-sticky-content'));
        var placeholder = $(anchor.attr('data-sticky-placeholder'));
        var origAnchorTop = null;
        var fixedClass = 'sticky-fixed';

        $(window).on('scroll resize', function (e) {
            var docTop = doc.scrollTop();
            var anchorTop = anchor.offset().top;
            var placeholderHeight = placeholder.height();
            var contentHeight = content.height();

            if (content.hasClass(fixedClass)) {
                if (docTop <= origAnchorTop) {
                    origAnchorTop = null;
                    content.removeClass(fixedClass);
                    content.css('top', 'auto');
                    placeholder.height(0);
                }
            } else {
                if (docTop > anchorTop) {
                    origAnchorTop = anchorTop;
                    content.addClass(fixedClass);
                    content.css('top', '-' + anchorTop + 'px');
                    placeholder.height(contentHeight);
                }
            }
        });
    });

    // Navbar toggler
    // Most of the work is done by Bootstrap:
    // https://getbootstrap.com/docs/4.0/components/collapse/
    // We add a class to the body as well, to make the menu full-screen,
    // instead of just pushing the content down.
    var navbarCollapsing = $('#navbar-collapsing');
    var bodyClass = 'body-navbar-shown';
    navbarCollapsing
        .on('show.bs.collapse', function(e) {
            $('body').addClass(bodyClass);
        })
        .on('hide.bs.collapse', function(e) {
            $('body').removeClass(bodyClass);
        });
    // If the window is resized resulting in the collapsed header no longer
    // being shown, collapse the menu as well, which restores the body to
    // scrollable.
    $(window).on('resize', function(e) {
        if (!$('#header-collapsed').is(':visible')) {
            navbarCollapsing.collapse('hide');
        }
    });

    // FAQ
    // TODO Use Bootstrap multi-collapse instead: https://getbootstrap.com/docs/4.0/components/collapse/#accordion-example
    var faqHolder = $("#faqholder");
    faqHolder.find('div.faq').hide();
    faqHolder.find('h3').click(function (e) {
        $(this).next('div').toggle();
    });
});


//TODO REMOVE
function JqueryElements() {
    $('.FormElement').addClass("ui-widget-content ui-corner-all");
    $('.FormElement').focus(function () {
        $(this).addClass('ui-state-focus');
    });
    $('.FormElement').blur(function () {
        $(this).removeClass('ui-state-focus');
    });

    $("input[type='button'], input[type='submit']").button();
//    $('input[type=checkbox]').checkbox().bind('ui-checkbox-changed' +' ui-checkbox-enabled ui-checkbox-disabled' +' ui-checkbox-focus ui-checkbox-blur');
}

//function loadrecipe(title, id) {
//    var url = '../getajaxrecipe/?id='+id;
//    $("#dialog").load(url).dialog({width:900, height:700, modal:true, title: title})
//}
function sendmail(title, id) {
    var url = '../getmapfunctions/?function=getmail&id=' + id;
    $("#dialog").load(url).dialog({
        width: 500,
        height: 300,
        modal: true,
        title: "Stuur mail naar " + title
    })
}

function sendactualmail() {
    validate = validateForm(document.sendform);
    if (validate) {
        $.ajax({
            type: "POST",
            url: "../getmapfunctions/",
            data: {
                from: $("#van").val(),
                to: $("#to").val(),
                recv_id: $("#recv_id").val(),
                message: $("#message").val()
            },
            success: function (html) {
                $("#sendmailresponse").show();
                $("#sendmailresponse").html(html);
            }
        });
    }
}

function checkMail(email) {
//var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/igm;
//var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    var re = /(.+)@(.+){2,}\.(.+){2,}/;
    if (!re.test(email)) {
        $.msgBox({
            title: "Uh-oh...",
            content: "Voer een valide e-mail adres in.",
            msgBoxImagePath: "http://veganchallenge.nl./wp-content/themes/veganchallenge2/images/"
        });
        return true;
    }
}

function validateForm(form) {

    console.log('hello');

    var isNVV = 0;

    for (var e = 0; e < form.elements.length; e++) {


        var el = form.elements [e];

        if (el.name == 'NVV') {
            isNVV = 1;
            return true;
        }

        if (el.name == 'Email' || el.name == 'email') {
            var x = el.value;
            if (checkMail(x)) {
                return false;
            }
        }


        if (el.className != 'optional') {
            if (el.type == 'text' || el.type == 'textarea' ||
                el.type == 'password' || el.type == 'file') {
                // check text fields
                if (el.value == '' || $.trim(el.value) == '') {
                    $.msgBox({
                        title: "Uh-oh...",
                        content: 'Vul het ' + el.name + ' veld in'
                    });
                    el.focus();
                    return false;
                }
            }
        }
        else if (el.type.indexOf('select') != -1) {
            if (el.value == 'none') {
                if (el.value == '') {
                    $.msgBox({
                        title: "Uh-oh...",
                        content: 'Vul het ' + el.name + ' veld in'
                    });
                    el.focus();
                    return false;
                }
            }
        }
        else if (el.type == 'radio') {
            // check radio button groups
            var group = form [el.name];
            var checked = false;
            if (!group.length) checked = el.checked;
            else
                for (var r = 0; r < group.length; r++)
                    if (( checked = group [r].checked ))
                        break;
            if (!checked) {
                if (el.value == '') {
                    $.msgBox({
                        title: "Uh-oh...",
                        content: 'Vul het ' + el.name + ' veld in'
                    });
                    el.focus();
                    return false;
                }
            }
        }
        else if (el.type == 'checkbox') {
            // check checkbox groups
            var group = form [el.name];
            if (group.length) {
                var checked = false;
                for (var r = 0; r < group.length; r++)
                    if (( checked = group [r].checked ))
                        break;
                if (!checked) {
                    if (el.value == '') {
                        $.msgBox({
                            title: "Uh-oh...",
                            content: 'Vul het ' + el.name + ' veld in'
                        });
                        el.focus();
                        return false;
                    }
                }
            }
        }
    }
    return true;
}
